
define(
	'RSM.PriceLevelInventoryDisplay.Module'
,   [
		'RSM.PriceLevelInventoryDisplay.Module.View'
	]
,   function (
		ModuleView
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container) {
			var layout = container.getComponent('Layout');
			var pdp = container.getComponent('PDP');
			
			if(pdp && layout) {
				pdp.addChildView('StockDescription', function() {
					return new ModuleView({
						container: container,
						pdp: pdp
					});
				});
			}
		}
	};
});
